import t from "../../translations";

export const enumChecker = {
  userNotFound: "auth/user-not-found",
  invalidEmail: "auth/invalid-email",
  wrongPassword: "auth/wrong-password",
  weakPassword: "auth/weak-password",
  differentPasswords: "auth/different-passwords",
  emailAlreadyInUse: "auth/email-already-in-use",
  agreementNotChecked: "auth/agreementNotChecked",
  tooManyRequest: "auth/too-many-requests",
  // emptyNameMessageBox: "auth/argument-error",
  // emptyMessageBox: "auth/argument-error",
  emptyNameMessageBox: "auth/argument-error-name",
  emptyMessageBox: "auth/argument-error-message",
};

const checker = (code) => {
  const emailNotExist = t('error_Email_Not_Exist');
  const emailBadlyFormatted = t('error_Email_Badly_Formatted');
  const invalidPassword = t('error_Invalid_Password');
  const invalidlengthOfPassword = t('error_Invalid_Length_Of_Password');
  const passwordsDoNotMatches = t('error_Passwords_Do_Not_Matches');
  const userAlreadyInUse = t('error_User_Already_In_Use');
  const agreementNotChecked = t('error_Agreemnt_Not_Checked');
  const tooManyRequest = t('error_Too_Many_Request');
  const emptyNameMessageBox = t('error_Empty_Name_Message_Box');
  const emptyMessageBox = t('error_Empty_Message_Box');

  switch (code) {
    case enumChecker.userNotFound:
      return emailNotExist;

    case enumChecker.invalidEmail:
      return emailBadlyFormatted;

    case enumChecker.weakPassword:
      return invalidlengthOfPassword;

    case enumChecker.wrongPassword:
      return invalidPassword;

    case enumChecker.differentPasswords:
      return passwordsDoNotMatches;

    case enumChecker.emailAlreadyInUse:
      return userAlreadyInUse;

    case enumChecker.agreementNotChecked:
      return agreementNotChecked;

    case enumChecker.tooManyRequest:
      return tooManyRequest;

    case enumChecker.emptyNameMessageBox:
      return emptyNameMessageBox;

    case enumChecker.emptyMessageBox:
      return emptyMessageBox;

    default:
      return null;
  }
};

export default checker;
